import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorContentState: LoadableType<any> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorContentStateEditorContentState" */ '../src/EditorContentState/EditorContentState.tsx'
			)
		).EditorContentState,
});
